import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IconBell } from "@/components/icons";

import { ROUTES } from "@/config/routes";
import { useNotificationsCount } from "@/hooks/api/user.hooks";

const NotificationBtn = () => {
  const { data: notifications } = useNotificationsCount();
  const { t } = useTranslation();
  return (
    <li>
      <Link
        to={ROUTES.NOTIFICATIONS.MAIN}
        title={t("General.notifications")}
        className={"relative block rounded-full p-2 "}
      >
        <IconBell className={"size-6 stroke-white stroke-2"} />

        {notifications?.data.count_unread_notifications ? (
          <span
            className={
              "absolute right-1 top-1 flex size-4 min-w-max items-center justify-center rounded-full bg-orange-1 p-1 text-xs"
            }
          >
            {notifications.data.count_unread_notifications}
          </span>
        ) : null}
      </Link>
    </li>
  );
};

export default NotificationBtn;
